<template>
  <div class="bg-box wh100p df-c-ct plr100">

    <div class="w100p df">
      <div class="f1 df-l-c-fs">

        <div class="df-l-c-fs mb40">
          <img class="logo" src="@/assets/images/logo-pure-blue.svg" alt="">
          <div class="_themecolor f-xxs mt20">Digitalize your restaurant business</div>
        </div>

        <div class="form-box p40">
          <div class="texts">
            <div>
              <span>{{$t('login.welcome')}}</span>
              <span class="f-xxxl _themecolor" v-if="pswLeng===4">{{waiter_x.nickName}}</span>
              <span class="f-xxxl _themecolor" v-else-if="pswLeng===6">{{user_x.nickName}}</span>
            </div>
            <div class="mt10">{{$t('login.youNeed')}}</div>
          </div>
          <div class="df mt20">
            <div class="df-l">
              <div>
                <div :class="status===1?'whitebtn-m':'darkbtn-m'" @click="status===1&&clockBefore(1)">{{$t('login.workinClock')}}</div>
              </div>
              <div class="mt20">
                <div :class="status===2?'whitebtn-m':'darkbtn-m'" @click="status===2&&clockBefore(2)">{{$t('login.workoutClock')}}</div>
              </div>
            </div>
            <div class="df-l ml40">
              <div>
                <div :class="status===2?'whitebtn-m':'darkbtn-m'" @click="status===2&&clock(3)">{{$t('login.restStart')}}</div>
              </div>
              <div class="mt20">
                <div :class="status===3?'whitebtn-m':'darkbtn-m'" @click="status===3&&clock(4)">{{$t('login.restEnd')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="f1 df-l-sb">
        <div class="f1 df-sb">
          <div>
            <div>
              <span class="f-xxxl">{{time}}</span>
              <template v-if="status===2||status===3">
                <span class="plr20">|</span>
                <span :class="status===2?'status':'_themecolor'">
                  <span>{{$t('login.workStatus'+status)}}</span>
                  <span class="pl20">{{computeTime}}</span>
                </span>
              </template>
            </div>
            <div class="mt20 mb10">{{$t('key.day'+weekday)}}</div>
            <div>{{date}}</div>
          </div>
          <div>
            <div class="mb20">
              <div class="themebtn-m" @click="finish">{{$t('login.finish')}}</div>
            </div>
            <div class="mb20">
              <div class="themebtn-m" @click="enter">{{$t('login.enterPos')}}</div>
            </div>
          </div>
        </div>
        <div class="w100p">
          <el-table :data="clockDate" height="400" border>
            <el-table-column align="center" min-width="140" prop="t1" :label="$t('login.date')"></el-table-column>
            <el-table-column align="center" min-width="120" prop="t2" :label="$t('login.workin')"></el-table-column>
            <!-- <el-table-column align="center" min-width="120" prop="t3" :label="$t('login.workout')"></el-table-column> -->
            <el-table-column align="center" min-width="120" :label="$t('login.workout')">
              <template slot-scope="scope">
                <span v-html="scope.row.t3"></span>
              </template>
            </el-table-column>
            <el-table-column align="center" min-width="120" prop="t4" :label="$t('login.resttime')"></el-table-column>
            <el-table-column align="center" min-width="120" prop="t5" :label="$t('login.worktime')"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <DialogCamera
      ref="DialogCamera"
      :title="$t(`login.${['','workinClock','workoutClock'][clickType]}`)"
      @submitDialog="submitDialogCamera" />

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import DialogCamera from '@/components/DialogCamera'
export default {
  name: 'clock',
  components: { DialogCamera },
  data() {
    return {
      pswLeng: '',
      time: '',
      weekday: '',
      date: '',
      lastStartTime: 0,
      timeHistory: 0,
      computeTime: 0,
      timer_countdown: null,
      timer_getScene: null,

      status: 1, // 1未工作 2工作中 3休息中
      clockDate: [],

      clickType: 0,
    }
  },
  methods: {
    ...mapMutations(['sceneId_x_save', 'modelList_x_save']),
    finish() {
      this.$router.back()
    },
    enter() {
      this.getCurrentScene()
    },

    // 获取 当前场景
    getCurrentScene() {
      return this.$api.current_scene_search({
        shopId: this.shop_x.id,
      }).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c当前场景:`, 'color: #00f;', _R)
          if (_R) {
            this.sceneId_x_save(_R.id)
            this.modelList_x_save(_R.runModuleSceneList)
            const ITEM_MODEL = _R.runModuleSceneList.find(x => x.type === 0)

            if (ITEM_MODEL && ITEM_MODEL.enable) {
              this.$router.push(`table`)
            } else {
              this.$router.push(`menu?type=fastfood`)
            }
          } else {
            this.sceneId_x_save('')
            this.modelList_x_save([])
            this.$router.push(`menu?type=fastfood`)
          }
            
        } else { this._status(res) }
      })
    },

    async clockBefore(type) {
      this.clickType = type
      if (this.isShowWaiterTakePhoto) {
        this.$refs.DialogCamera.open()
      } else {
        this.clock(type)
      }
    },
    submitDialogCamera(imgId) {
      console.log(`%csubmitDialogCamera:`, 'color: #f00;', imgId)
      if (imgId) {
        this.clock(this.clickType, imgId)
      } else {
        this.clock(this.clickType)
      }
    },
    async clock(type, imgId) {
      const rD = {
        companyId: this.shop_x.companyId,
        shopId: this.currentShopId,
        employeeId: {4:this.waiter_x.id,6:this.user_x.id}[this.pswLeng],
        type,
        clockInTime: this.$tool.time_get_timeStamp(),
        // workImg: imgId
      }
      if (imgId) {
        rD.workImg = imgId
      }
      await this.newData('clock', rD)
      this.getClock()
    },
    async getClock() {
      const rD = {
        shopId: this.currentShopId,
        employeeId: {4:this.waiter_x.id,6:this.user_x.id}[this.pswLeng],
      }

      this.$api.waiter_clock_type_get(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c允许的操作:`, 'color: #f00;', _R)
          const { currentStatus, startWorkTime, startBreakTime, breakDuration } = _R
          this.status = currentStatus
          if (currentStatus === 2) {
            this.lastStartTime = startWorkTime
            this.timeHistory = 0 - breakDuration
          } else if (currentStatus === 3) {
            this.lastStartTime = startBreakTime
            this.timeHistory = breakDuration
          }

          this.getDate2()
        } else { this._status(res) }
      })

      let _R = await this.getData('clock', rD)
      console.log(`%c打卡记录:`, 'color: #f00;', _R)
      this.clockDate = _R.map(x1 => {
        const obj = {
          t1: x1.currentDay,
          t2: x1.startWorkTime ? this.$tool.time_parse_hms(x1.startWorkTime) : '',
          // t3: x1.endWorkTime ? this.$tool.time_parse_ymd(x1.endWorkTime) : '',
          t4: this.$tool.time_timeStamp_to_m(x1.breakDuration || 0),
          t5: this.$tool.time_timeStamp_to_h(x1.workDuration || 0),
        }
        if (x1.endWorkTime) {
          const T3 = this.$tool.time_parse_ymd(x1.endWorkTime, '-', 'hms')
          if (T3.includes(x1.currentDay)) {
            obj.t3 = T3.substring(11)
          } else {
            obj.t3 = `<span>${T3.substring(11)}</span><br/><span>(${T3.substring(0, 10).replace(/-/g, '/')})</span>`
          }
        } else {
          obj.t3 = ''
        }
        return obj
      })
    },

    getDate() {
      this.weekday = this.$tool.time_get_weekDay()
      // console.log(`%c星期:`, 'color: #f00;', this.weekday)
      const DATE = this.$tool.time_parse_ymd(new Date(), '/', 'hms')
      // console.log(`%cDATE:`, 'color: #f00;', DATE)
      this.time = DATE.substring(11)
      this.date = DATE.substring(0, 10)
    },
    getDate2() {
      if (this.lastStartTime) {
        const T = this.$tool.time_get_timeStamp()
        this.computeTime = this.$tool.time_timeStamp_to_hms(T - this.lastStartTime + this.timeHistory)
      }
    },
    
    setTimer() {
       // 设置定时查询当前场景，避免与服务器断开连接
      this.timer_getScene && clearInterval(this.timer_getScene)
      this.timer_getScene = setInterval(() => {
        this.$api.current_scene_search({
          shopId: this.shop_x.id,
          autoOnlyBendRead: true,
        })
      }, 30000)

      this.timer_countdown && clearInterval(this.timer_countdown)
      this.timer_countdown = setInterval(() => {
        this.getDate()
        this.getDate2()
      }, 1000)
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.pswLeng = Number(to.query.type)
  
      vm.getDate()

      vm.setTimer()

      if ({4:vm.waiter_x.id,6:vm.user_x.id}[vm.pswLeng]) {
  
        vm.getClock()

      } else {

        vm.$message.error(vm.$t('error.illegalPage'))

        let timer_leavepage = setTimeout(() => {
          vm.$router.back()
          clearTimeout(timer_leavepage)
        }, 2000)

      }
    })
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer_countdown)
    clearInterval(this.timer_getScene)
    next()
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_table.scss';
.bg-box{
  position: relative;box-sizing: border-box;
}
.logo{width: 210px;}
.form-box{
  border: 2px solid #ECEEF4;
  .texts{line-height: 24px;min-width: 200px;max-width: 300px;}
}
.status{color: rgb(68, 138,255);}
</style>